import { render, staticRenderFns } from "./QrcodeReader.vue?vue&type=template&id=68fd3994&scoped=true&"
import script from "./QrcodeReader.vue?vue&type=script&lang=js&"
export * from "./QrcodeReader.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeReader.vue?vue&type=style&index=0&id=68fd3994&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fd3994",
  null
  
)

export default component.exports